import { render, staticRenderFns } from "./Weicai.vue?vue&type=template&id=13a636f9&scoped=true&"
import script from "./Weicai.vue?vue&type=script&lang=js&"
export * from "./Weicai.vue?vue&type=script&lang=js&"
import style0 from "./Weicai.vue?vue&type=style&index=0&id=13a636f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a636f9",
  null
  
)

export default component.exports